import _ from 'lodash';
import { carouselProductLimit } from 'shared/constants/products';

export const defaultFilters = {
  perPage: carouselProductLimit,
  sortBy: `popularSortIdx`,
  useCache: true,
};

// NOTE: the server is responsible for preventing low inventory items from appearing here
// limit carousels to 15 products
export const applySettings = (products) => products.splice(0, 15);

export const checkNeedToMakeEdibleIngestible = (dispensaryState, category) =>
  dispensaryState === 'PA' && _.toLower(category) === 'edible';

export const replaceEdibleWithIngestible = (categoryProperty) => {
  if (_.includes(categoryProperty, `Edible`)) {
    return _.replace(categoryProperty, `Edible`, `Ingestible`);
  }

  if (_.includes(categoryProperty, `edible`)) {
    return _.replace(categoryProperty, `edible`, `ingestible`);
  }

  return categoryProperty;
};
